import React from 'react'

import { ErrorBox, StateBox } from '../style'
import DatabaseField from '../DatabaseField'
import {
    ActionButton,
    ActionsCell,
    DeleteButton,
    EditingRow,
    SaveButton,
    Table,
    TableWrapper,
} from './style'
import { useDatabaseTable } from './useDatabaseTable'
import { getItemId } from '../utils/tableHelpers'

const DatabaseTable = () => {
    const {
        selectedTable,
        tableData,
        columns,
        referenceOptions,
        referencesLoading,
        loading,
        saving,
        error,
        editError,
        editingRowId,
        editRowData,
        isEditing,
        handleEditStart,
        handleEditFieldChange,
        handleEditSave,
        handleDelete,
        cancelEditingRow,
        formatCellValue,
    } = useDatabaseTable()

    if (loading) {
        return <StateBox>Загрузка данных...</StateBox>
    }

    if (tableData.length === 0) {
        return <StateBox>Нет данных для отображения</StateBox>
    }

    return (
        <>
            {error && <ErrorBox>{error}</ErrorBox>}
            {editError && <ErrorBox>{editError}</ErrorBox>}

            <TableWrapper>
                <Table>
                    <thead>
                        <tr>
                            {columns.map((column) => (
                                <th key={column}>{column}</th>
                            ))}
                            <th>Действия</th>
                        </tr>
                    </thead>

                    <tbody>
                        {tableData.map((row, rowIndex) => {
                            const rowId = getItemId(row)
                            const rowIsEditing = editingRowId !== null && editingRowId === rowId
                            const RowComponent = rowIsEditing ? EditingRow : 'tr'

                            return (
                                <RowComponent key={rowId || rowIndex}>
                                    {columns.map((column) => (
                                        <td key={column}>
                                            {rowIsEditing ? (
                                                <DatabaseField
                                                    field={column}
                                                    value={editRowData[column]}
                                                    onChange={handleEditFieldChange}
                                                    selectedTable={selectedTable}
                                                    referenceOptions={referenceOptions}
                                                    referencesLoading={referencesLoading}
                                                    withLabel={false}
                                                />
                                            ) : (
                                                formatCellValue(row[column])
                                            )}
                                        </td>
                                    ))}

                                    <ActionsCell>
                                        {rowIsEditing ? (
                                            <>
                                                <SaveButton
                                                    type="button"
                                                    onClick={() => handleEditSave(row)}
                                                    disabled={saving}
                                                >
                                                    {saving ? 'Сохранение...' : 'Сохранить'}
                                                </SaveButton>
                                                <ActionButton
                                                    type="button"
                                                    onClick={cancelEditingRow}
                                                    disabled={saving}
                                                >
                                                    Отмена
                                                </ActionButton>
                                            </>
                                        ) : (
                                            <>
                                                <ActionButton
                                                    type="button"
                                                    onClick={() => handleEditStart(row)}
                                                    disabled={isEditing}
                                                >
                                                    Изменить
                                                </ActionButton>
                                                <DeleteButton
                                                    type="button"
                                                    onClick={() => handleDelete(row)}
                                                    disabled={isEditing}
                                                >
                                                    Удалить
                                                </DeleteButton>
                                            </>
                                        )}
                                    </ActionsCell>
                                </RowComponent>
                            )
                        })}
                    </tbody>
                </Table>
            </TableWrapper>
        </>
    )
}

export default DatabaseTable
